module.exports = __webpack_public_path__ + "img/patrulla_municipal_down_selected.b2a688d1.svg";